module.exports = {"updown_read_key":"ro-6tqPw8pUAAL7QXzndby3","twitter":"datang.my","website_name":"Datang.my","website_url":"https://datang.my","logo_url":"https://datang.my/img/logo.png"}


//////////////////
// WEBPACK FOOTER
// ./page_config.json
// module id = Yr1l
// module chunks = 1